import HasCouponPage from './HasCouponPage';
import './HasCouponPage.css';

export default HasCouponPage;



// WEBPACK FOOTER //
// ./src/pages/Account/containers/HasCouponPage/index.js